import { GET_SERVICECITY_REQUESTED, GET_SERVICEREGION_REQUESTED, GET_ADDSERVICEREGION_REQUESTED,GET_SUBVENDORREGION_REQUESTED, GET_ADDSUBVENDORREGION_REQUESTED } from "resources/actionTypes";


export function getServiceCity(data) {
  return{
    type: GET_SERVICECITY_REQUESTED,
    payload: data
  };
}

export function getServiceRegion(data) {
  return{
    type: GET_SERVICEREGION_REQUESTED,
    payload: data
  };
}

export function postAddServiceRegion(userAddServiceRegion) {
  const data = {
    userAddServiceRegion: userAddServiceRegion,
  }
  return {
    type: GET_ADDSERVICEREGION_REQUESTED,
    payload: data,
  };
}

export function getSubVendorRegion(data) {
  return{
    type: GET_SUBVENDORREGION_REQUESTED,
    payload: data
  };
}

export function postAddSubVendorRegion(userAddSubVendorRegion) {
  const data = {
    userAddSubVendorRegion: userAddSubVendorRegion,
  }
  return {
    type: GET_ADDSUBVENDORREGION_REQUESTED,
    payload: data,
  };
}
